import React from 'react';
import Publications from '../components/User/Publications/Publications';

function PublicationsPage() {
  return (
    <>
      <Publications />
    </>
  );
}

export default PublicationsPage;